<template>
  <v-container id="table-extrato" class="pa-0 mt-0">
    <v-col class="d-flex justify-end pb-2 px-0" cols="12">
        <v-btn color="primary" text @click="getFile()" :disabled="list.length == 0">
          <v-icon small class="pr-2">fa-download</v-icon>
          Exportar 
        </v-btn>
      </v-col>
      <v-row
        class="ma-0 pl-4 pr-2" 
        style="background-color: #d1dcea; margin-bottom: 10px !important;">
        <v-col cols="2" class="pa-4">
          <div class="px-5 pt-1">
            <b class="pr-2">TOTAIS</b>
          </div>
        </v-col>
        <v-col cols="10" class="pa-0">
          <v-row class="ma-0 pt-1 pr-11" style="justify-content: end;">
            <v-spacer/>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. informado:</small><br />
              <b><span>{{ totais.valor_informado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. liberado:</small><br />
              <b><span style="color: rgb(50, 184, 139)">{{ totais.valor_liberado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. glosado:</small><br />
              <b><span style="color: red">{{ totais.valor_glosado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl.lib. de recurso:</small><br />
              <b><span style="color: rgb(50, 184, 139)">{{ totais.valor_pago_recurso | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Glosa mantida:</small><br />
              <b><span style="color: red; font-weight: 400;">{{ totais.valor_glosa_mantida | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. recursado:</small><br />
              <b><span style="font-weight: 400;">{{ totais.valor_recursado | formatPrice }}</span></b>
            </v-col>
            <v-col class="text-list text-right px-0 py-1" style="max-width:11.6%">
              <small>Vl. acatado:</small><br />
              <b><span style="color: rgb(50, 184, 139); font-weight: 400;">{{ totais.valor_acatado | formatPrice }}</span></b>
            </v-col>
          </v-row>  
        </v-col>              
      </v-row>
    <v-data-table
      dense
      hide-default-footer
      :headers="headers"
      :items="list"
      min="-1"
      max="15"
      ref="guiasListTable"
      class="lotesListTable"
      @update:options="ordenacao"
    >
      <template v-slot:header >
        <thead class="v-data-table-header" >
          <tr>
            <th colspan="3" style="border-bottom: none; text-align: center">Informações gerais</th>
            <th colspan="5" style="border-bottom: none; text-align: center">Pagamentos da data</th>
            <th colspan="2" style="border-bottom: none; text-align: center">Recurso de Glosa</th>
            <th style="border-bottom: none; text-align: center"></th>
          </tr>
        </thead>
      </template>
      <template v-slot:item.etapa="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="pa-0">
              <v-icon :color="getStatusData(item.etapa, 'cor')" size="13px" class="pr-1">fas fa-circle</v-icon >
            </span>
          </template>
          <span 
            class="px-3 py-1 ma-0"
            style="
                  border: solid 1px #999;
                  border-radius: 5px;
                  background-color: #fff;
                "
            >{{getStatusData(item.etapa, 'descricao')}}</span >
        </v-tooltip>
      </template>
      <template v-slot:item.data_pagamento="{ item }">
        {{ item.data_pagamento | formatDate }}
      <!-- <v-tooltip bottom v-if='["processado","publicado", "lote_pendente", "em_analise", "a_enviar", "enviado", "com_critica"].includes(item.etapa)'>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="pa-0">
                <v-btn
                  class="py-0 px-0" 
                  color="primary"
                  small 
                  icon
                  to="/recebiveis/consultadepagamentos/detalhespagamento">
                  <v-icon class="pa-0" small>fas fa-external-link-alt</v-icon>
                </v-btn>
              </span>
            </template>
            <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
              Ver detalhes do pagamento
            </span>
          </v-tooltip> -->
      </template>

      <template v-slot:item.valor_informado="{ item }">
        <b v-if="item.valor_informado">{{ item.valor_informado | formatPrice}}</b>
      </template>
      <template v-slot:item.valor_glosado="{ item }">
        <b style="color:#D0021B"  v-if="item.valor_glosado">{{ item.valor_glosado | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_liberado="{ item }">
        <b style="color:#32B88B" v-if="item.valor_liberado">{{ item.valor_liberado | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_pago_recurso="{ item }">
        <b style="color:#32B88B" v-if="item.valor_pago_recurso">{{ item.valor_pago_recurso | formatPrice }}</b>
      </template>
      <template v-slot:item.valor_glosa_mantida="{ item }">
        <span style="color:#D0021B" v-if="item.valor_glosa_mantida">{{ item.valor_glosa_mantida | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_recursado="{ item }">
        <span v-if="item.valor_recursado">{{ item.valor_recursado | formatPrice }}</span>
      </template>
      <template v-slot:item.valor_acatado="{ item }">
        <span style="color:#31B1FF" v-if="item.valor_acatado">{{ item.valor_acatado | formatPrice }}</span>
      </template>
    </v-data-table>
    <p class="text-right"><small>Valores em Reais (R$)</small></p>
    <v-row>
      <v-col cols="4"></v-col>
      <v-col class="text-center mt-2 py-0" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="pagination.offset"
          :length="pagination.total_pages"
          @input="getList(filterData, pagination.offset)"
        ></v-pagination>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
moment.locale('pt-BR');
export default {
  data() {
    return {
      // statusList: {
      //   identificado: { text:'Pagamento identificado' ,icon: 'fas fa-search-dollar', color:'#979797' },
      //   processamento: { text:'Pagamento em processamento', icon: 'fas fa-cogs', color:'#4A4A4A' }, //fa-hourglass-half
      //   processado: { text:'Pagamento processado', icon: 'fas fa-clipboard-check', color:'#31B1FF' }, // fa-thumbtack
      //   publicado: { text:'Pagamento publicado', icon: 'fas fa-newspaper', color:'#B2B842'}, 
      //   em_analise: { text:'Recurso em analise', icon: 'fas fa-microscope', color:'#FC9D0A' }, 
      //   a_enviar: { text:'Recurso aguardando envio', icon: 'fas fa-clock', color:'#FC5F17' },
      //   enviado: { text:'Recurso enviado', icon: 'fas fa-paper-plane', color:'#32B88B' }, 
      //   com_critica: { text:'Recurso com crítica', icon: 'fas fa-exclamation-circle', color:'#D0021B' }, 
      // },
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    selectedGuias(val) {
      this.selectGuias(val)
    },
    list(list) {
      if (list) {
        setTimeout(() => {
          let index = list.reduce((total, elem, ind) => { if(elem.is_editada){ total.push(ind) } return total }, [])
          index.forEach( el => this.$refs['guiasListTable'].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[el].setAttribute('class', 'active'))
        },500)
      }
    }
  },
  methods: {
    getStatusData(id, param){
      let status = this.statusList.find(el=> el.id == id)
      return status? status[param] : ''
    },
    selecionaTodos(selection) {
      if (selection.value) {
        this.selectedGuias = [...selection.items];
      } else {
        this.selectedGuias = [];
      }
    },
    selecaoUnica(selection) {
      if (selection.value) {
          this.selectedGuias.push(selection.item);
      } else {
        let ind = this.selectedGuias.findIndex( item => item == selection.item)
        this.selectedGuias.splice(ind, 1)
      }
    },
    ordenacao(item) {
      let sort = item.sortBy[0] ? item.sortBy[0] : null;
      let order = item.sortDesc.length > 0 ? (item.sortDesc[0] ? "Desc": "Asc") : null;
      let newFilter = {...this.filterData, sort, order}
      this.getList(newFilter, 1)
    },
  },
  props: {
    getList: Function,
    list: Array,
    headers: Array,
    pagination: Object,
    filterData: Object,
    getFile: Function,
    statusList: Array,
    totais: Object
  },
}
</script>

<style lang="scss">
#table-extrato {
  .no-box-shadow, .no-box-shadow *{
    box-shadow: 0 0 0 0!important;
  }
  .theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 13px !important;
  }
}
</style>